import { render, staticRenderFns } from "./AreYouSureTextInput.vue?vue&type=template&id=1d82cbe0&scoped=true&"
import script from "./AreYouSureTextInput.vue?vue&type=script&lang=ts&"
export * from "./AreYouSureTextInput.vue?vue&type=script&lang=ts&"
import style0 from "./AreYouSureTextInput.vue?vue&type=style&index=0&id=1d82cbe0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d82cbe0",
  null
  
)

export default component.exports